export const NUMERIC_DATE_TIME_FORMAT = "dd-MM-yyyy HH:mm:ss";
export const UTC_DATE_TIME_FORMAT = ""; // moment's `format` method defaults to UTC
export const LOCAL_DATE_TIME_FORMAT = "ll LTS";
export const LOCAL_DATE_FORMAT = "L";
// Reference: https://momentjs.com/docs/#/displaying/format/ for the different formats string options

export const TIMESTAMP = Object.freeze({
  UNITS: {
    SECONDS: "seconds",
    MILLISECONDS: "milliseconds",
  },
  ZONE: {
    LOCAL: "local",
    UTC: "utc",
  },
});
